export default __webpack_public_path__ + "static/media/honesty2Img6.cba161d8.png";